import "./header.scss"

import {Link, NavLink, useLocation, useNavigate} from "react-router-dom";
import {BurgerMenuIcon, HeaderArrIcon, Logo} from "../../assets/images";
import {appLanguage} from "../../graphql/reactive-variables";
import {Languages, NavDropdown} from "../../utils/constanats";
import {useReactiveVar} from "@apollo/client";
import {apolloClient} from "../../graphql/client";
import {Dropdown, Space} from "antd";
import {GetUrlWithLocal} from "../../utils/getUrlWithLocal";

function Header(props) {
    const {mobileMenuOpen, toggleMobileMenu, translations, setMemberships} = props
    const language = useReactiveVar(appLanguage)
    const location = useLocation()
    const navigate = useNavigate();

    function changeLanguage(lang) {
        if (language !== lang) {
            appLanguage(lang);
            localStorage.setItem("language", lang);
            apolloClient.resetStore();

            const pathname = location.pathname;
            const prevLang = pathname.split("/").at(-1);

            if (prevLang === Languages.en || prevLang === Languages.hy) {
                const newPath = pathname.slice(0, -prevLang.length) + lang;
                navigate(newPath, {replace: true});
            }
        }
    }

    const languageMenu = {
        items: Object.values(Languages)
            .filter(code => code !== language)
            .map(code => ({
                key: code,
                label: (
                    <div
                        className="language-dropdown-item"
                        onClick={() => changeLanguage(code)}
                    >
                        {translations?.[`header_languages_${code}`]}
                    </div>
                )
            }))
    };

    const navigationMenu = {
        items: NavDropdown.map((item, index) => ({
            key: index,
            label: (
                <NavLink
                    to={GetUrlWithLocal(item.path)}
                    className={({isActive}) => (isActive ? "active" : "none")}
                >
                    {translations?.[item.title]}
                </NavLink>
            )
        }))
    };

    return (
        <div className="header-wrapper">
            <Link to={GetUrlWithLocal("/home")} onClick={() => setMemberships(false)}>
                <div className="orange-logo">
                    <Logo title="" />
                </div>
            </Link>

            <ul className="nav-menu">
                <div className={'nav_dropdown'}>
                    <Dropdown trigger={["hover"]} menu={navigationMenu}>
                        <div className="nav-dropdown-trigger">
                            {translations?.header_nav_dropdown_title || 'Օրանժ'}
                            <HeaderArrIcon />
                        </div>
                    </Dropdown>

                </div>

                <NavLink to={GetUrlWithLocal("/packages")}
                         className={({isActive}) => (isActive ? "active" : 'none')}>
                    <li className="nav-item">{translations?.header_membership}</li>
                </NavLink>

                <NavLink to={GetUrlWithLocal("/fitness")}
                         className={({isActive}) => (isActive ? "active" : 'none')}>
                    <li className="nav-item">{translations?.header_item_fitness}</li>
                </NavLink>

                <NavLink to={GetUrlWithLocal("/spa")}
                         className={({isActive}) => (isActive ? "active" : 'none')}>
                    <li className="nav-item">{translations?.header_item_spa}</li>
                </NavLink>

                <NavLink to={GetUrlWithLocal("/cafe")}
                         className={({isActive}) => (isActive ? "active" : 'none')}>
                    <li className="nav-item">{translations?.header_item_cafe}</li>
                </NavLink>

                {/*<NavLink to={GetUrlWithLocal("/about")}*/}
                {/*         className={({isActive}) => (isActive ? "active" : 'none')}>*/}
                {/*    <li className="nav-item">{translations?.header_item_about}</li>*/}
                {/*</NavLink>*/}

                {/*<NavLink to={GetUrlWithLocal("/news")}*/}
                {/*         className={({isActive}) => (isActive ? "active" : 'none')}>*/}
                {/*    <li className="nav-item">{translations?.header_item_events}</li>*/}
                {/*</NavLink>*/}

                {/*<NavLink to={GetUrlWithLocal("/contact")}*/}
                {/*         className={({isActive}) => (isActive ? "active" : 'none')}>*/}
                {/*    <li className="nav-item">{translations?.header_item_contact}</li>*/}
                {/*</NavLink>*/}

                {/*<NavLink to={GetUrlWithLocal("/partners")}*/}
                {/*         className={({isActive}) => (isActive ? "active" : 'none')}>*/}
                {/*    <li className="nav-item">{translations?.partners_menu_title}</li>*/}
                {/*</NavLink>*/}

                <NavLink to={GetUrlWithLocal("/vacancy")}
                         className={({isActive}) => (isActive ? "active" : 'none')}>
                    <li className="nav-item">{translations?.vacancy_menu_title}</li>
                </NavLink>


                <div className="language-block">
                    <Dropdown trigger={["click"]} menu={languageMenu}>
                        <a onClick={(e) => e.preventDefault()}>
                            <Space>
                                <div className="selected-language">
                                    {translations?.[`header_languages_${language}`]}
                                    <HeaderArrIcon />
                                </div>
                            </Space>
                        </a>
                    </Dropdown>
                </div>

                <a className="header_burger" onClick={toggleMobileMenu}>
                    <BurgerMenuIcon />
                </a>
            </ul>
        </div>
    );
}

export default Header;
